import { ImageModel } from "../imageModel";
import { MedicineSpecificationContentModel } from './medicineSpecificationContentModel';

export class AdminMedicineSpecificationModel {
  public medicineSpecificationId: number;
  public medicineId: number;
  public description: string;
  public pharmaceuticalForm: string;
  public imprint: string;
  public strength: string;
  public color: string;
  public size: string;
  public shape: string;
  public packaging: string;
  public packageSize: string;
  public ddd: string;
  public score: string;
  public itemCode: string;
  public flavour: string;
  public contains: string;
  public productTypeId: number;
  public firstAuthorizationDate: string;
  public lastAuthorizationDate: string;
  public roaTypeId?: number;
  public images: Array<ImageModel>;
  public medicineSpecificationContent: Array<MedicineSpecificationContentModel>;
}